import { DataResult, GroupDescriptor } from '@progress/kendo-data-query';
import { WidgetID } from '../../../models/widget.model';
import { useDispatch } from 'react-redux';
import { setGridConfig } from '../../../store/slices/grid-config.slice';
import { GridGroupChangeEvent } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import { usePersistGrid } from './usePersistUserGrid';
import { GridConfig } from '../../../models/grid-config.model';

export function useGridWithGrouping(id: WidgetID) {
  const dispatch = useDispatch();

  const { gridConfig, storeConfig } = usePersistGrid(id);
  const grouping: GroupDescriptor[] = gridConfig?.group ?? [];

  const onGroupChange = useCallback(
    async (e: GridGroupChangeEvent) => {
      const nextGroup = e.group.map((descriptor: GroupDescriptor) => {
        return {
          ...descriptor,
          dir: descriptor.dir ? descriptor.dir : 'asc',
        };
      });

      const updatedData: GridConfig = {
        ...gridConfig,
        group: nextGroup,
      };
      const nextConfig = {
        id: id,
        data: updatedData,
      };
      dispatch(setGridConfig(nextConfig));
      await storeConfig({
        [id]: updatedData,
      });
    },
    [dispatch, id, storeConfig, gridConfig]
  );

  const transformRow = (row: any): any => {
    const transformedRow = {
      ...row,
      field: row.member ?? '',
      value: row.key ?? '',
    };

    // If the row contains nested data, apply transformation recursively
    if (row.hasSubgroups) {
      return {
        ...transformedRow,
        items: row.items.map(transformRow),
      };
    }

    return transformedRow;
  };

  const transformGridGroupedData = (gridResult: DataResult): DataResult => {
    const result = {
      ...gridResult,
      data: gridResult.data.map(transformRow),
    };
    return result;
  };

  return { grouping, onGroupChange, transformGridGroupedData };
}
